import axios from 'axios';

export const createEvent = async ({ headers, payload }) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_EVENT_BASE_URL}/`, payload, {
      headers
    });
    return response.data;
  } catch (err) {
    if (err.response) {
      // TODO: Melhorar a validação
      if (err.response.data.duplicated) {
        throw new Error('duplicated');
      } else {
        throw new Error(err.response.data.message);
      }
    } else {
      throw new Error(err.message);
    }
  }
};

export const updateEvent = async ({ headers, payload, id }) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${id}`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      if (err.response.data.duplicated) {
        throw new Error('duplicated');
      } else {
        throw new Error(err.response.data.message);
      }
    } else {
      throw new Error(err.message);
    }
  }
};

export const listEvents = async (authUserId) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/?producerId=${authUserId}`
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const getEvent = async (id) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_EVENT_BASE_URL}/${id}`);
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const activateEvent = async ({ headers, id }) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${id}/activate`,
      {},
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const inactivateEvent = async ({ headers, id }) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${id}/inactivate`,
      {},
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};
